import { OrganizationSchema } from '@common/schemas/entities/organization.schema';
import { z } from 'zod';

/** DTO shape = raw Firestore document, inferred from common OrganizationSchema */
export type OrganizationDTO = z.infer<typeof OrganizationSchema>;

/**
 * Organization Form schema.
 * Extends Common schema with UI-only fields.
 */
export const OrganizationFormSchema = OrganizationSchema.omit({ audit: true }).extend({
  id: z.string().optional(),
  pendingFiles: z.array(z.instanceof(File)).optional(),
}).passthrough();

export type OrganizationFormValues = z.infer<typeof OrganizationFormSchema>;
